import {
  Switch as RawSwitch,
  SwitchProps as RawSwitchProps,
} from '@mantine/core';
import { useFormState } from 'components/elements/form';
import { useController } from 'react-hook-form';

export interface SwitchInputProps extends RawSwitchProps {
  type: 'switch';
  name: string;
}

export default function SwitchInput(props: SwitchInputProps) {
  const { onChange, disabled, readOnly, name, type, error, ...rest } = props;
  const formState = useFormState();
  const { field, fieldState } = useController({
    name,
  });

  const _disabled = formState.editable === false || disabled || readOnly;
  const _error = fieldState.error?.message || error;

  return (
    <RawSwitch
      {...rest}
      {...field}
      disabled={_disabled}
      error={_error}
      value={field.value}
      onChange={(e) => {
        field.onChange(e.currentTarget.checked);
        onChange?.(e);
      }}
    />
  );
}
